import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { Layout } from './components/Layout';
import { LoginPage } from './pages/LoginPage';
import { DashboardPage } from './pages/DashboardPage';
import { CampsPage } from './pages/CampsPage';
import { EquipmentPage } from './pages/EquipmentPage';
import { PacksPage } from './pages/PacksPage';
import { UsersPage } from './pages/UsersPage';
import { AlmanacPage } from './pages/AlmanacPage';
import { ExportPage } from './pages/ExportPage';
import { AuditPage } from './pages/AuditPage';
import { MapPage } from './pages/MapPage';
import { TrailsPage } from './pages/TrailsPage';
import { POIsPage } from './pages/POIsPage';
import { AreasPage } from './pages/AreasPage';
import { PropertiesPage } from './pages/PropertiesPage';
import { GroupsPage } from './pages/GroupsPage';
import { EventsPage } from './pages/EventsPage';
import { ApprovalRequestsPage } from './pages/ApprovalRequestsPage';
import { CampSitesPage } from './pages/CampSitesPage';

function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        color: '#888888',
        fontSize: 16,
      }}>
        Loading...
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
}

function AppRoutes() {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        color: '#888888',
        fontSize: 16,
      }}>
        Loading...
      </div>
    );
  }

  return (
    <Routes>
      <Route
        path="/login"
        element={user ? <Navigate to="/" replace /> : <LoginPage />}
      />
      <Route
        path="/*"
        element={
          <ProtectedRoute>
            <Layout>
              <Routes>
                <Route path="/" element={<DashboardPage />} />
                <Route path="/properties" element={<PropertiesPage />} />
                <Route path="/camps" element={<CampsPage />} />
                <Route path="/cabins" element={<CampsPage />} />
                <Route path="/camp-sites" element={<CampSitesPage />} />
                <Route path="/equipment" element={<EquipmentPage />} />
                <Route path="/packs" element={<PacksPage />} />
                <Route path="/users" element={<UsersPage />} />
                <Route path="/almanac" element={<AlmanacPage />} />
                <Route path="/trails" element={<TrailsPage />} />
                <Route path="/pois" element={<POIsPage />} />
                <Route path="/areas" element={<AreasPage />} />
                <Route path="/map" element={<MapPage />} />
                <Route path="/export" element={<ExportPage />} />
                <Route path="/audit" element={<AuditPage />} />
                <Route path="/groups" element={<GroupsPage />} />
                <Route path="/events" element={<EventsPage />} />
                <Route path="/approval-requests" element={<ApprovalRequestsPage />} />
                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
            </Layout>
          </ProtectedRoute>
        }
      />
    </Routes>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppRoutes />
      </BrowserRouter>
    </AuthProvider>
  );
}
